import { render, staticRenderFns } from "./CouponForBundleTable.vue?vue&type=template&id=3d630a90&"
import script from "./CouponForBundleTable.vue?vue&type=script&lang=js&"
export * from "./CouponForBundleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports